import type { Dispatch, SetStateAction } from "react";
import { useCallback } from "react";
import { extractClientCodeFromUrl } from "../utilities/clientHelper";

export interface ClientCodeFromWebsiteUrlAccessors<TForm> {
  getClientCode: (form: TForm) => string;
  getWebsiteUrl: (form: TForm) => string;
  setClientCode: (form: TForm, clientCode: string) => TForm;
}

export const useClientCodeFromWebsiteUrl = <TForm>(
  form: TForm,
  setForm: Dispatch<SetStateAction<TForm>>,
  accessors: ClientCodeFromWebsiteUrlAccessors<TForm>
): (() => void) => {
  const { getClientCode, getWebsiteUrl, setClientCode } = accessors;

  return useCallback(() => {
    if (getClientCode(form).trim()) {
      return;
    }

    setTimeout(
      () =>
        setForm((prev) => setClientCode(prev, extractClientCodeFromUrl(getWebsiteUrl(prev)) || getClientCode(prev))),
      100
    );
  }, [form, setForm, getClientCode, getWebsiteUrl, setClientCode]);
};
